import LaptopIcon from '@mui/icons-material/Laptop';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import COLORS from '../../theme/Colors';
import {
    Container,
    RowContainer,
    Subtitle,
    SpecialSubtitle,
    Title,
    Separator,
    FullSeparator,
    BodyText,
    ButtonsContainer,
    ServiceButton,
    ServiceSecondaryButton,
    OrderComponent
} from './styles/ServiceCardStyles';

// Importar íconos
import CommunicationsIcons from '../../assets/icons/CommunicationsIcons.png';
import DesarrolloIcon from '../../assets/icons/DesarrolloIcon.png';
import EnergyIcons from '../../assets/icons/EnergyIcons.png';
import FlyIcon from '../../assets/icons/FlyIcon.png';
import InvestIcon from '../../assets/icons/InvestIcon.png';
import iconsProfitIcon from '../../assets/icons/icons8-profit.svg';
import InvestCoinIcon from '../../assets/icons/icons8-investment-80.png';

function ServiceCard({ iconName, relationTo, title, subTitle, onRequestPress, OnViewInformationPress, imageUrl }) {
    // Mapeo de íconos por relación o categoría
    const iconMap = {
        // Valores de localDirections
        'SECTOR TURISMO': FlyIcon,
        'Turismo': FlyIcon,
        'Telecomunicaciones': CommunicationsIcons,
        'Energía': EnergyIcons,
        'Infraestructura': DesarrolloIcon,
        'Servicios al Inversionista': InvestIcon,
        'Otros servicios al inversionista': iconsProfitIcon,
        'DIRECCIÓN GENERAL DE ALIANZAS PÚBLICO-PRIVADAS (DGAPP)': InvestCoinIcon,
        'Trámites Dirección General de Cine': FlyIcon,
        'Ley No.12-21 Consejo De Coordinación Zona Especial De Desarrollo Fronterizo (CZOEDF)': InvestIcon,
        'ayuntamientos': InvestIcon,
        // Agregar otros posibles valores
        'Migración': DesarrolloIcon,
        'Centro de Desarrollo y Competitividad Industrial (PROINDUSTRIA)': InvestCoinIcon,
        'Ministerio de Energía y Minas': EnergyIcons,
        'Ayuntamientos': InvestIcon,
    };

    // Seleccionar ícono: primero intenta imageUrl del backend, luego busca en iconMap por relationTo, si no usa un ícono por defecto
    // Manejar strings vacíos explícitamente
    const selectedIcon = (imageUrl && imageUrl.trim() !== '') ? imageUrl : (iconMap[relationTo] || InvestIcon);

    return (
        <Container>
            <div style={{ width: '95%', alignSelf: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img 
                        src={selectedIcon} 
                        alt={title}
                        style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = InvestIcon;
                        }}
                    />
                </div>
                <RowContainer>
                    <Subtitle>RELACIONADO A: </Subtitle>
                    <SpecialSubtitle style={{ color: COLORS.primary }}>{relationTo}</SpecialSubtitle>
                </RowContainer>
                <Title>{title}</Title>

            </div>
            <div>
                <BodyText>
                    {subTitle}
                </BodyText>
            </div>

            < ButtonsContainer>
                <ServiceButton onClick={onRequestPress} endIcon={<LaptopIcon />}>SOLICITAR</ServiceButton>
                <ServiceSecondaryButton onClick={OnViewInformationPress} endIcon={<HelpOutlineIcon />}>VER INFORMACIÓN</ServiceSecondaryButton>
            </ButtonsContainer >

        </Container >

    );
}

export default ServiceCard;